import EPG from './EPG';

export default EPG;
